// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"09b57502","377":"9d0a052a"}[chunkId] + ".chunk.css";
};